import Highcharts from 'highcharts';
import { filterByCategory } from './data.js';

function getPouczeniaMandaty() {
    const data = filterByCategory(['Mandaty: liczba wystawionych', 'Pouczenia: liczba', 'Liczba mieszkańców'])
    
    // Filtruj miasta z kompletnymi danymi
    const validData = data.filter(sm => 
        sm['Mandaty: liczba wystawionych'] && 
        sm['Pouczenia: liczba'] && 
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Pouczenia: liczba'] === 'number'
    )
    
    validData.forEach(sm => {
        // Oblicz stosunek mandatów do pouczeń
        sm.mandatyNaPouczenie = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Pouczenia: liczba']) * 100) / 100
        
        // Oblicz na ile mandatów przypada jedno pouczenie
        sm.pouczenieNaMandaty = Math.round((sm['Pouczenia: liczba'] / sm['Mandaty: liczba wystawionych']) * 100) / 100

        sm.mandatyNaPouczenia = Math.round(10 / sm.pouczenieNaMandaty) / 10
        
        // Oblicz mandaty na 100k mieszkańców
        sm.mandatyPer100k = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Liczba mieszkańców']) * 100000)
        
        // Oblicz pouczenia na 100k mieszkańców  
        sm.pouczeniaPer100k = Math.round((sm['Pouczenia: liczba'] / sm['Liczba mieszkańców']) * 100000)
        
        // Oblicz łączną liczbę interwencji
        sm.lacznie = sm['Mandaty: liczba wystawionych'] + sm['Pouczenia: liczba']
        
        // Oblicz procent pouczeń w stosunku do wszystkich interwencji
        sm.procentPouczen = Math.round((sm['Pouczenia: liczba'] / sm.lacznie) * 100)
    })
    
    return validData.sort((a, b) => b.mandatyNaPouczenia - a.mandatyNaPouczenia)
}

export default function chartPouczenia(id) {
    if (!document.getElementById(id)) return;

    const data = getPouczeniaMandaty();
    
    // Wykres słupkowy - stosunek pouczeń do mandatów
    const chartData = data.map(sm => ({
        name: sm.city,
        y: sm.mandatyNaPouczenia,
        mandaty: sm['Mandaty: liczba wystawionych'],
        pouczenia: sm['Pouczenia: liczba'],
        procentPouczen: sm.procentPouczen
    }));

    Highcharts.chart(id, {
        chart: {
            type: 'column',
            height: 600
        },
        title: {
            text: 'Stosunek mandatów do pouczeń',
            style: {
                fontSize: '18px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            text: 'Na ile mandatów przypada jedno pouczenie (wyższe wartości = mniej pouczeń)'
        },
        xAxis: {
            categories: chartData.map(item => item.name),
            labels: {
                rotation: -45,
                style: {
                    fontSize: '11px'
                }
            }
        },
        yAxis: {
            title: {
                text: 'Pouczenia na mandat'
            },
            min: 0
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    format: '{y}',
                    style: {
                        fontSize: '10px'
                    }
                },
                colorByPoint: true
            }
        },
        tooltip: {
            pointFormat: '<b>{point.name}</b><br/>Mandaty na pouczenie: <b>{point.y}</b>'
        },
        series: [{
            type: 'column',
            name: 'Mandaty na pouczenie',
            data: chartData,
            showInLegend: false
        }],
        credits: {
            enabled: false
        }
    });
}